import styled from 'styled-components'
import { isMobile, isTablet } from 'react-device-detect'

import { font, greys, fontFamily } from 'assets/themes/theme-default'
import { Radio, RadioButton, Row, Col } from 'core/components/ui'

const { Group } = Radio

export const InterTitle = styled.h3`
  font-size: ${font.size.lg};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  color: ${greys.dark1};
`

export const StyledGroup = styled(Group)`
  width: 100%;
`

export const InputWrapper = styled(Row)`
  margin: ${isMobile ? '10px 0 20px' : '25px 0 25px'};
`

export const SVGWrapper = styled.div`
  display: ${isMobile && !isTablet && 'none'};
`
export const StyledRadioButton = styled(RadioButton)`
  &&& {
    margin-right: 0px;
    display: ${isMobile && !isTablet && 'block'};
  }
`
export const StyledRadioButtonMobile = styled(RadioButton)`
  &&& {
    margin-right: 0px;
    height: auto;
    line-height: initial;
    padding: 10px;
  }
  & svg {
    height: 70px;
  }
  &.ant-radio-button-wrapper {
    &&& span > span {
      font-size: ${font.size.xxs};
    }
    &-checked {
      background-color: #fff !important;
      span {
        color: ${props => props.theme.colors.color1.bg} !important;
      }
    }
  }
`
export const StyledMessage = styled.span`
  font-size: ${font.size.xs};
  display: block;
`

export const StyledCol = styled(Col)`
  text-align: center;
`
